import { useMemo } from 'react';
import { PAGE_NAME, TrackingProvider } from '@givelify/utils';
import GivelifyLogo from 'assets/givelify-deposits-logo.svg';
import dayjs from 'dayjs';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { webConfig } from 'webConfig';
import { PATH } from '../../router/routes';
import { ActionButton, Copyright, ImgWrapper, Title, Wrapper } from './styles';

export const DepositDownload = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const currentYear = dayjs().year();

    const copy = useMemo(
        () => ({
            title: t('depositsDownload.title'),
            buttonText: t('depositsDownload.buttonText'),
            copyright: t('depositsDownload.copyright', {
                year: currentYear,
            }),
        }),
        [currentYear, t],
    );

    const handleClick = () => {
        const reportId = searchParams.get('reportId');

        navigate(
            reportId
                ? PATH.REPORTS.REPORT_HISTORY_DOWNLOAD + `?reportId=${reportId}`
                : PATH.REPORTS.REPORT_HISTORY,
        );
    };

    return (
        <TrackingProvider trackPageVisit pageName={PAGE_NAME.DepositDownload}>
            <GoogleReCaptchaProvider reCaptchaKey={webConfig.googleSiteKey}>
                <Wrapper>
                    <ImgWrapper>
                        <img alt="Givelify" src={GivelifyLogo} />
                    </ImgWrapper>
                    <Title fontWeight={800} variant="heading1S">
                        {copy.title}
                    </Title>
                    <ActionButton
                        onClick={handleClick}
                        size="large"
                        text={copy.buttonText}
                        variant="primary"
                    />
                    <Copyright variant="body2">{copy.copyright}</Copyright>
                </Wrapper>
            </GoogleReCaptchaProvider>
        </TrackingProvider>
    );
};
